module.exports = __webpack_public_path__ + "static/media/1POLICY26.254a4c16.jpg";